export default __webpack_public_path__ + "static/media/hht1_ep16_timeline_q04_b.13864861.png";